import React from "react";
import { withRouter } from "react-router";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    // this.setState({
    //   error: error,
    //   errorInfo: errorInfo,
    // });
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // Error path
      return (
        <div
          style={{
            backgroundColor: "#0f0718",
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <h1 className="ErrorText"
            style={{
              fontSize: "5rem",
              color: "#ffffff",
              margin: 0,
              lineHeight: "200px",
              fontWeight: 700,
              "@media (max-width: 767px)": {
                fontSize: "4.688rem",
                lineHeight: "120px",
              },
            }}
          >
            Sorry! Something Went Wrong
          </h1>
          <div>
            <button type="button" onClick={() => window.history.back()}>
              Go back
            </button>{" "}
            <button type="button" onClick={() => window.location.reload()}>
              Please Retry
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
